<template>
  <div class="sidebar">
    <div class="logo d-flex" @click='$router.push("/homepage")'>
      <img src="@/assets/logoIcon.png" alt="TeamsMagic" class="sidebar-tm-logo-icon" />
      <img src="@/assets/loginPageLogo.png" alt="TeamsMagic" class="sidebar-tm-logo" />
    </div>
    <!-- Dropdown App Switcher -->

    <div class="app-switcher-dropdown" v-if="hasBothProducts">
      <button class="dropdown-toggle" @click="toggleDropdown">
        <i :class="activeProductIcon"></i>
        <span>{{ activeProductLabel }}</span>
        <i class="dropdown-chevron" :class="{ 'rotated': dropdownOpen }"></i>
      </button>
      <div class="dropdown-menu1" v-show="dropdownOpen">
        <div class="dropdown-item1" @click="switchProduct('Engage')" :class="{ 'active': activeProduct === 'Engage' }">
          <i class="fas fa-users"></i>
          <span>Engage</span>
        </div>
        <div class="dropdown-item1" @click="switchProduct('Interview')"
          :class="{ 'active': activeProduct === 'Interview' }">
          <i class="fas fa-comments"></i>
          <span>Interviews</span>
        </div>
      </div>
    </div>
    <ul class="sidebar-nav">
      <li class="nav-item" v-for="(item, index) in filteredTabs" :key="index"
        :class="{ 'nav-item-disabled': item.disabled }">
        <router-link :to="item.route" class="nav-link" active-class="active-tab"
          :class="{ 'disabled-link': item.disabled }" :exact=true>
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
          <i v-if="item.disabled" class="fas fa-lock lock-icon"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { tabs } from "../../mixins/tabs";
export default {
  data() {
    return {
      activeProduct: 'Engage',
      hasBothProducts: false,
      dropdownOpen: false
    };
  },
  computed: {
    tabPermission() {
      return this.$store.state.userInfo?.Permission.split(",") || [];
    },
    activeProductName() {
      return this.activeProduct;
    },
    filteredTabs() {
      return tabs.filter((e) => {

        const formattedName = e.permission_name.toLowerCase().replace(/\s+/g, "_");

        if (formattedName === "home") return true;


        //check for product permission
        if (e.product == "Engage") {
          return this.tabPermission.includes("marketplace") && this.tabPermission.includes(formattedName) && this.activeProductName == e.product;
        }
        else if (e.product == "Interview") {
          return this.tabPermission.includes("interviews") && this.tabPermission.includes(formattedName) && this.activeProductName == e.product;
        }

        return false;
      });
    },
    allPermittedTabs() {
      return tabs.filter((e) => {

        const formattedName = e.permission_name.toLowerCase().replace(/\s+/g, "_");

        if (formattedName === "home") return true;
        return this.tabPermission.includes(formattedName);

      });
    },
    activeProductIcon() {
      return this.activeProduct === 'Engage'
        ? 'fas fa-users'
        : 'fas fa-comments';
    },
    activeProductLabel() {
      return this.activeProduct === 'Engage'
        ? 'TM Engage'
        : 'TM Interviews';
    },
  },
  created() {
    this.checkProductsAccess();
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    switchProduct(product) {
      this.activeProduct = product;
      this.$store.commit("setActiveProduct", this.activeProduct);
      const defaultRoute = this.filteredTabs[0]?.route || '/';
      this.dropdownOpen = false;
      if (this.$route.path !== "/homepage") { this.$router.push(defaultRoute); }
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.dropdownOpen = false;
      }
    },
    checkProductsAccess() {
      const hasEngage = this.tabPermission.some(p => p.includes('marketplace'));
      const hasInterviews = this.tabPermission.some(p => p.includes('interviews'));
      this.hasBothProducts = hasEngage && hasInterviews;

      const activeTab = this.allPermittedTabs.filter(tab => tab.route == this.$route.path);
      if (activeTab.length > 0) {
        if (activeTab[0].name == "Home") {
          const oldActiveProduct = this.$store.state.activeProduct;
          if (oldActiveProduct) {
            this.activeProduct = oldActiveProduct;
          } else {
            if (!this.hasBothProducts) {
              this.activeProduct = hasEngage ? 'Engage' : 'Interview';
              this.$store.commit("setActiveProduct", this.activeProduct);
            } else {
              this.activeProduct = 'Engage';
              this.$store.commit("setActiveProduct", this.activeProduct);
            }
          }

        } else {
          this.activeProduct = activeTab[0].product;
          this.$store.commit("setActiveProduct", activeTab[0].product);
        }

      }

    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);

  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped src="./sidebar.css"></style>
<style scoped>
/* Add these styles to your sidebar.css */
.app-switcher-dropdown {
  position: relative;
  margin: 1rem;
  z-index: 1;
}

.dropdown-toggle {
  width: 100%;
  padding: 0.75rem 1rem;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  color: var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dropdown-toggle:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.dropdown-toggle i:first-child {
  margin-right: 0.75rem;
  font-size: 0.9rem;
}

.dropdown-chevron {
  transition: transform 0.2s ease;
  font-size: 0.8rem;
  margin-left: auto;
  padding-left: 0.75rem;
}

.dropdown-chevron.rotated {
  transform: rotate(180deg);
}

.dropdown-menu1 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-top: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 10;
}

.dropdown-item1 {
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #495057;
}

.dropdown-item1:hover {
  background: #f8f9fa;
  color: #3a86ff;
}

.dropdown-item1.active {
  background: #f0f7ff;
  color: #3a86ff;
  font-weight: 500;
}

.dropdown-item1 i {
  margin-right: 0.75rem;
  font-size: 0.9rem;
  width: 16px;
  text-align: center;
}
</style>
